var $name="devices",$path="configs/devices.js",$this={$name,$path,};const unkwnown = require('./unknown');

module.exports = {
  ...unkwnown,
  desktop: 'desktop',
  mobile: 'mobile',
  tablet: 'tablet',
};
